/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ place: NonNullable<unknown> }} Aiflowaskplaceunpinned4Inputs */

const en_aiflowaskplaceunpinned4 = /** @type {(inputs: Aiflowaskplaceunpinned4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I found "${i?.place}" but could not place it on the map. Where exactly is it?`)
};

const de_aiflowaskplaceunpinned4 = /** @type {(inputs: Aiflowaskplaceunpinned4Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ich habe „${i?.place}“ gefunden, aber nicht auf der Karte. Wo genau ist das?`)
};

/**
* | output |
* | --- |
* | "I found \"{place}\" but could not place it on the map. Where exactly is it?" |
*
* @param {Aiflowaskplaceunpinned4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowaskplaceunpinned4 = /** @type {((inputs: Aiflowaskplaceunpinned4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowaskplaceunpinned4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowaskplaceunpinned4(inputs)
	return de_aiflowaskplaceunpinned4(inputs)
});
export { aiflowaskplaceunpinned4 as "aiFlowAskPlaceUnpinned" }